/**
 * Regra de negócio da lista do PWA: só animais vivos.
 *
 * NÃO filtrar com `if (animal.isActive)` — `undefined`/`null` são vivos
 * (default do cadastro). Situação B = baixa/saída do rebanho.
 *
 * NÃO voltar a listar via `GET /animals/producer?page&size` compartilhado
 * entre count/page: a API usa smartPage default size=20 e a lista parava em ~20.
 * Usar sync completo + fatia no cliente (`AnimalsRepository.loadAllLiving`).
 */
export function isLivingAnimal(animal: {
    isActive?: boolean | null;
    active?: boolean | null;
    situation?: string | null;
}): boolean {
    const situation =
        animal.situation != null ? String(animal.situation).toUpperCase() : null;
    if (situation === 'B') {
        return false;
    }
    // Registro cru do IndexedDB/Mongo pode trazer `active` em vez de `isActive`
    return (animal.isActive ?? animal.active) !== false;
}

/** Fatia de página no cliente (lista completa já em memória). */
export function sliceAnimalPage<T>(
    list: T[],
    page?: { first: number; rows: number; enabled?: boolean } | null
): T[] {
    if (!page || page.enabled === false || !(page.rows > 0)) {
        return list;
    }
    return list.slice(page.first, page.first + page.rows);
}
